import { render, staticRenderFns } from "./BgqwPage20.vue?vue&type=template&id=3bd9f79d"
import script from "./BgqwPage20.vue?vue&type=script&lang=js"
export * from "./BgqwPage20.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports